<mat-toolbar>
    <div class="navbar-container">
      <div class="branding" routerLink="/utilities">
        <img src="assets/NeuroLogo10.png" alt="Neuro Utilities Logo" width="40" height="40">
        <span>Neuro Utilities</span>
      </div>
  
      <div class="nav-links">
        <a mat-button routerLink="/utilities" routerLinkActive="active">
            <mat-icon class="nav-link-icon">construction</mat-icon>
            <span class="nav-link-text">Utilities</span>
        </a>
        <a mat-button routerLink="/tenant-management" routerLinkActive="active">
            <mat-icon class="nav-link-icon">group</mat-icon>
            <span class="nav-link-text">Tenant Management</span>
        </a>
      </div>
  
      <div class="right-actions">
        <button mat-icon-button (click)="themeService.toggleTheme()">
          <mat-icon class="theme-icon">{{themeService.getThemeIcon()}}</mat-icon>
        </button>
        <div class="user-profile">
            <button mat-icon-button [matMenuTriggerFor]="userMenu">
                <mat-icon class="user-icon">account_circle</mat-icon>
            </button>
            <mat-menu #userMenu="matMenu">
              <button mat-menu-item (click)="onLogout()">
                  <mat-icon>logout</mat-icon>
                  <span>Sign out</span>
              </button>
          </mat-menu>
        </div>

      </div>
    </div>
  </mat-toolbar>